// Copyright ©️ 2026 eVolve MEP, LLC

import { createModalRegistry } from 'components/Mantine/Modals/createModalRegistry';
import { BendQAModal } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendQAModal';
import { FabItemsWillUpdateWOModal } from 'modules/Shop/EvolveFabrication/FabItemsWillUpdateWOModal';
import { ManageBendCustomPropertiesModal } from 'modules/Shop/EvolveFabrication/ManageBendCustomPropertiesModal';

/**
 * Modals opened imperatively while working with machine elements.
 */
export const [
  MachineElementActionsModalProvider,
  useMachineElementActionsModals,
  useMachineElementVariableTrackingModals,
] = createModalRegistry({
  customProperties: ManageBendCustomPropertiesModal,
  bendQaModal: BendQAModal,
  fabItemsWillUpdateWOModal: FabItemsWillUpdateWOModal,
});
